/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import CreditCardModal from 'app/components/Subscription/CreditCardModal.jsx';
import ConfirmationModal from 'app/components/Subscription/ConfirmationModal.jsx';
import PricingMatrix from 'app/components/Subscription/PricingMatrix.jsx';
import SubscriptionFeatureBlock from 'app/components/Subscription/SubscriptionFeatureBlock.jsx';
import SupportedNetworks from 'app/components/Subscription/SupportedNetworks.jsx';
import Loading from 'app/components/common/Loading.jsx';
import { Link } from 'react-router-dom';
import * as _ from 'underscore';
import PlanDetailBlock from 'app/components/Subscription/PlanDetailBlock.jsx';
import ErrorBoundary from 'app/components/common/ErrorBoundary.jsx';
import GetPlanData from 'app/utility/GetPlanData.js';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import EmptyState from 'app/components/common/EmptyState.jsx';
import StarterLimitModal from 'app/components/Subscription/StarterLimitModal.jsx';
import SubscriptionPauseModal from 'app/components/Subscription/SubscriptionPauseModal.jsx';
import { setLauncherVisible } from 'app/utility/Intercom.js';

class SubscriptionNew extends React.Component {
    constructor(props) {
        super(props);

        let currentPlan = 6,
            currentTerm = 2,
            addOns = 0;

        if (window.location.search !== '') {
            let matches = window.location.search.match(/plan=([\d]+)/);
            if (matches !== null && matches[1] !== undefined) {
                currentPlan = parseInt(matches[1]);
            }

            let termMatches = window.location.search.match(/term=([\d]+)/);
            if (termMatches !== null && termMatches[1] !== undefined) {
                currentTerm = parseInt(termMatches[1]);
            }

            let addOnMatches = window.location.search.match(/addons=([\d]+)/);
            if (addOnMatches !== null && addOnMatches[1] !== undefined) {
                addOns = parseInt(addOnMatches[1]);
            }
        }

        this.state = {
            newSubscription: {
                level: currentPlan,
                term: currentTerm,
                addOns: addOns
            },
            errors: null,
            infoRolloverActive: false,
            processing: false,
            showConfirmationModal: false
        };

        this.openCreditCardModal = this.openCreditCardModal.bind(this);
        this.openConfirmationModal = this.openConfirmationModal.bind(this);
        this.startUpgrade = this.startUpgrade.bind(this);
        this.closeConfirmationModal = this.closeConfirmationModal.bind(this);
        this.changeTerm = this.changeTerm.bind(this);
        this.updateCurrentPlan = this.updateCurrentPlan.bind(this);
        this.goToSignup = this.goToSignup.bind(this);
        this.changePlanView = this.changePlanView.bind(this);

    }

    componentDidMount() {

        if (this.props.context === 'app') {
            this.checkLevel(this.props);
            if (_.isEmpty(this.props.plans.current)) {
                this.props.getSubscription();
            }
    		this.props.getPlans();
            this.props.getFavorites();
        }

        setLauncherVisible(false);

        if (dataLayer && this.props.context === 'app') {
            dataLayer.push({
                'event': 'checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': {'step': 1, 'option': 'New Subscriber'}
                    }
                }
            });

            // GA4 specific info
            let planDetail = GetPlanData.lookupDetails(
                this.state.newSubscription.level,
                this.state.newSubscription.term
            );
            if (planDetail) {
                dataLayer.push({
                    'event': 'view_item',
                    'currency': 'USD',
                    'value': planDetail.price,
                    'items': [{
                        item_id: planDetail.plan_id,
                        item_name: planDetail.plan_name,
                        price: planDetail.price,
                        quantity: 1,
                        item_variant: 'new'
                    }]
                });
            }
        }

        // catch internal navigation when coming from the promo page
        // if the link is coming from an email wait for the plan details
        // to get loaded in componentDidUpdate
        if (!_.isEmpty(this.props.plans.details)) {
            if (this.props.router.query !== null && this.props.router.query.code !== undefined) {
                if (this.props.router.query.code === 'intrial50') {
                    this.setState({
                        newSubscription: {
                            level: 6,
                            term: 1
                        }
                    }, () => {
                        this.startUpgrade();
                    });
                } else {
                    this.startUpgrade();
                }
            }
        }

    }

    componentDidUpdate(prevProps, prevState) {
        let products = [],
            processing = this.state.processing,
            constants = this.props.app.config.constants;

        if (prevProps.context !== 'app' && this.props.context === 'app') {
            this.checkLevel(nextProps);
        }

        if (_.isEmpty(prevProps.plans.details) && !_.isEmpty(this.props.plans.details)) {
            if (this.props.router.query !== null && this.props.router.query.code !== undefined) {
                if (this.props.router.query.code === 'intrial50') {
                    this.setState({
                        newSubscription: {
                            level: 6,
                            term: 1
                        }
                    }, () => {
                        this.startUpgrade();
                    });
                } else {
                    this.startUpgrade();
                }
            }
        }

        if (prevProps && prevProps.app.loading.SUB_LIMIT_CHECK === true && this.props.app.loading.SUB_LIMIT_CHECK === false) {
            // Free trial gets more socials than starter, if someone wants
            // to use starter but has 3 socials, they need to make the choice
            // if (!_.isEmpty(this.props.plans.expiredPlan) ||
            //     (this.props.user.detail.hasHadSubscription && this.props.plans.limitCheck.outputs < 0))  {
            //     this.props.addModal(
            //         <SubscriptionPauseModal
            //             {...this.props}
            //             newSubscription={this.state.newSubscription}/>
            //     );
            // } else if (!this.props.user.detail.hasHadSubscription && this.props.plans.limitCheck.outputs < 0) {
            //     this.props.addModal(
            //         <StarterLimitModal
            //             {...this.props}
            //             dismissModal={this.props.closeAllModals}
            //             confirmBasic={(e) => {
            //                 let nextSubscription = Object.assign({}, this.state.newSubscription);
            //                 nextSubscription.level = constants.PUB_LEVEL_15;
            //                 this.props.closeAllModals();
            //                 this.setState({
            //                     newSubscription: nextSubscription
            //                 }, () => {
            //                     this.openCreditCardModal();
            //                 });
            //             }}
            //             confirmStarter={(e) => {
            //                 this.props.closeAllModals();
            //                 this.openCreditCardModal();
            //             }}/>
            //     );

            // } else {
                this.openCreditCardModal();
            //}
        }

        let errors = this.props.getApiErrors('SUB_CREATE');

        if (errors.length) {
            // Compared by value: getApiErrors hands back a fresh copy of any error that
            // carries its request's post, so an identity check never settles and this
            // setState loops until React gives up.
            if (!_.isEqual(this.state.errors, errors[0])) {
                this.setState({
                    errors: errors[0]
                });
                if (this.props.recordEvent) {
                    this.props.recordEvent({
                        pub_id: this.props.user.detail.id,
                        event_name: 'Subscription Creation Error',
                        event_data: {
                            error: JSON.stringify(errors[0].errors)
                        }
                    })
                }
            }
            processing = false;
        } else {
            if (this.props.isStarterUser() || this.props.isBasicUser()) {
                this.props.getSocials(true);
            }
        }

        if (!errors.length && prevProps.app.loading.SUB_CREATE === true && this.props.app.loading.SUB_CREATE === false &&
            (prevProps.plans.current.planLevel === undefined || this.props.isFreeOrTrialUser(prevProps.plans.current.planLevel)) &&
            !this.props.isFreeOrTrialUser(this.props.plans.current.planLevel)) {
            this.props.closeAllModals();
            this.openConfirmationModal();

            this.props.deleteApiError('SUB_CREATE');
            this.setState({
                errors: null
            });

            let subscription = this.props.plans.current;
            // if (dataLayer) {
            //     let planDetail = GetPlanData.lookupDetails(
            //         this.state.newSubscription.level,
            //         this.state.newSubscription.term
            //     );
            //     products.push({
            //         'name': subscription.planName,     // Name or ID is required.
            //         'price': subscription.price,
            //         'quantity': 1,
            //         'variant': 'new'
            //     });
            //
            //     dataLayer.push({
            //         'event': 'purchase',
            //         'ecommerce': {
            //             'purchase': {
            //                 'actionField': {
            //                     'id': subscription.uuid, // Transaction ID. Required for purchases and refunds.
            //                     'revenue': subscription.price
            //                 },
            //                 'products': products
            //             }
            //         },
            //         // GA4 params
            //         'transaction_id': subscription.uuid,
            //         'value': 1,
            //         items: [
			// 			{
			// 				item_id: 'dlvrit_1',
			// 				item_name: 'dlvr.it premium plan',
			// 				price: 1.00,
			// 				quantity: 1
			// 			}
			// 		]
            //     });
            // }

            if (gtag) {
                let promoData = this.props.getPersistedData('gaPromo');

                gtag('event', 'purchase', {
                    transaction_id: subscription.uuid,
                    value: 1.00,
                    currency: 'USD',
                    items: [
                        {
                            item_id: 'dlvrit_1',
                            item_name: 'dlvr.it premium plan',
                            item_variant: 'New Plan',
                            price: 1.00,
                            quantity: 1,
                            promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                            promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                        }
                    ]
                });

                if (this.props.recordEvent) {
                    this.props.recordEvent({
                        pub_id: this.props.user.detail.id,
                        event_name: 'Subscription Created',
                        event_data: {
                            'name': subscription.planName,
                            promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                            promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                        }
                    })
                }

                this.props.clearPersistedData('gaPromo');
            }

            processing = false;

        }



        if (this.state.processing !== processing) {
            this.setState({
                processing
            });
        }

    }

	componentWillUnmount() {

        setLauncherVisible(true);

	}

    checkLevel(props) {

        let constants = this.props.app.config.constants;

        if (props.context === 'app') {
            if (!props.isFreeUser(props.user.detail.pubLevel) && !props.isTrialUser(props.user.detail.pubLevel)) {
                this.props.router.navigate(`/account/subscription${window.location.search}`);
            }
        }

    }

    openCreditCardModal() {
        let couponCode = '',
            constants = this.props.app.config.constants,
            addOns = null;

        // if (this.state.newSubscription.level === constants.PUB_LEVEL_6 && this.state.newSubscription.term === constants.SUBSCRIPTION_TERM_ANNUAL) {
        //     couponCode = 'march_percent'
        // }

        if (this.state.newSubscription.addOns) {
            addOns = {
                add_on_social: this.state.newSubscription.addOns
            };
        }

        let ccModal = (
            <CreditCardModal
                {...this.props}
                heading={"Expand your reach"}
                plan={this.state.newSubscription.level}
                planTerm={this.state.newSubscription.term}
                username={this.props.user.detail.username}
                router={this.props.router}
                closeAction={this.props.closeAllModals}
                errors={this.state.errors}
                changeTerm={this.changeTerm}
                autoCouponCode={couponCode}
                addOns={addOns}
                updateCurrentPlan={this.updateCurrentPlan} />
        );

        this.props.addModal(ccModal);

    }

    openConfirmationModal() {
        let modal = (
            <ConfirmationModal
                {...this.props}
                confirmationType="newsubscription"
                confirmationAction={this.closeConfirmationModal}
                setModal={this.closeConfirmationModal}
                planLevel={this.state.newSubscription.level}
                planTerm={this.state.newSubscription.term} />
        );

        this.props.addModal(modal);

    }

    startUpgrade(e) {

        let constants = this.props.app.config.constants;

        if (e) {
            e.preventDefault();
        }

        let term = (this.state.newSubscription.term == constants.SUBSCRIPTION_TERM_ANNUAL) ? ' Annual' : ' Monthly';

        if (this.props.recordEvent) {
            this.props.recordEvent({
                pub_id: this.props.user.detail.id,
                event_name: 'Start Checkout',
                event_data: {
                    plan: this.props.plans.details[this.state.newSubscription.level].label + term,
                    source: 'pricing'
                }
            })
        }

        this.props.limitCheck(this.state.newSubscription.level, 0);

        // open the credit card modal on a successful limitCheck
        // thanks starter plan

    }

    closeConfirmationModal() {

        this.props.getUser();
        this.props.getUserPerms();

        if (this.props.getSavedPath() !== '') {
            this.props.router.navigate(this.props.getSavedPath());
            this.props.recordPath('');
        } else {
            this.props.router.navigate('/share/automate');
        }

        this.props.closeAllModals();

    }

    changeTerm(e) {
        let newSubscription = this.state.newSubscription;

        if (e.stopPropagation !== undefined) {
            e.stopPropagation();
        }

        if (e.currentTarget.dataset.context && e.currentTarget.dataset.context === "modal") {
            if (this.props.recordEvent) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: 'CC Modal Term Change',
                    event_data: {
                        'selected-plan': this.state.newSubscription.level,
                        'new-term': e.currentTarget.dataset.term
                    }
                })
            }
        }

        newSubscription.term = parseInt(e.currentTarget.dataset.term, 10);

        this.setState({
            newSubscription
        });

    }

    updateCurrentPlan(e) {

        let plan = parseInt(e.currentTarget.dataset.plan, 10),
            term = parseInt(e.currentTarget.dataset.term, 10),
            coupon = (e.currentTarget.dataset.coupon !== undefined) ? e.currentTarget.dataset.coupon : null,
            addOns = parseInt(e.currentTarget.dataset.addOns, 10),
            newSubscription = this.state.newSubscription;

        if (!isNaN(plan)) {
            newSubscription.level = plan;
        }

        if (!isNaN(term)) {
            newSubscription.term = term;
        }

        if ((!isNaN(addOns))) {
            newSubscription.addOns = addOns;
        }

        this.setState({
            newSubscription
        });

        if (isNaN(addOns)) {
            this.props.router.navigate('/account/subscription/new');
        }

    }

    goToSignup(e) {

        let host = this.props.app.config.signupUrl;

        e.preventDefault();
        window.location.href = host + "/#modal=signup";

    }

    changePlanView(direction) {
        let nextSubscription = this.state.newSubscription,
            constants = this.props.app.config.constants,
            validPlans = [
                constants.PUB_LEVEL_6,
                constants.PUB_LEVEL_9,
            ],
            currentIndex = validPlans.indexOf(nextSubscription.level),
            nextIndex = 0,
            delta = 0;

        if (direction === 'prev') {
            delta = -1;
        } else if (direction === 'next') {
            delta = 1;
        }

        nextIndex = currentIndex + delta;
        if (nextIndex < 0) {
            nextIndex = validPlans.length - 1;
        } else if (nextIndex >= validPlans.length) {
            nextIndex = 0;
        }

        nextSubscription.level = validPlans[nextIndex];

        this.setState({
            subscription: nextSubscription
        });

    }

    render() {
        let constants = this.props.app.config.constants,
            content = null,
            additionalPlan = null,
            planLink = null,
            containerClass = (this.props.context === 'app') ? 'new-subscription' : 'new-subscription public',
            matrixContext = 'new',
            planHref = '',
            subscriptionBlockClass = 'subscription-content-block',
            termButtons = null;

        if (this.props.bannerVisible) {
            containerClass += ' banner-adjust';
        }

        if (this.props.user.detail.isAgent) {
			return (
				<div className="app-column content main">
					<main className="content-container">
						<EmptyState
							message="Sorry, we only allow the account owner to access this page"/>
					</main>
				</div>
			);
		}

        if (_.isEmpty(this.props.plans.details)) {
            return (
                <div className={containerClass}>
                    <div className={subscriptionBlockClass}>
                        <Loading />
                    </div>
                </div>
            );
        }

        let linkCopy = 'Need more info? Compare our plans.';
        if (this.props.context === 'app') {
            planHref = '/account/subscription/compare';
            planLink = (<Link to={planHref}>{linkCopy}</Link>);
        } else {
            planHref = '/pricing?compare=1';
            planLink = (<a href={planHref}>{linkCopy}</a>);
        }
        additionalPlan = (
            <div className="additional-plans">
                {planLink}
            </div>
        );

        let plusLink = '',
            plusLabel = '',
            plusPitch = null;
        if (this.props.isProUser(this.state.newSubscription.level) || this.props.isAgencyUser(this.state.newSubscription.level)) {
            plusLink = '/account/subscription/new?plan=9';
            plusLabel = "Plus";
            if (this.props.isAgencyUser(this.state.newSubscription.level)) {
                plusLink = '/account/subscription/new?plan=10';
                plusLabel = "Agency+";
            }
            plusPitch = (
                <div className="new-sub-plus-wrapper">
                    <a href={plusLink} className="new-sub-plus">
                        Social Media Power User? Get EverQueue, Categories and Bulk Import with {plusLabel}!
                    </a>
                </div>
            );
        }



        if ((this.props.router && this.props.router.location.pathname.match(/compare/))
            || window.location.search.match("compare=1")) {
            if (this.props.context !== 'app') {
                matrixContext = 'public';
                subscriptionBlockClass += ' public-matrix';
            }
            content = (
                <PricingMatrix
                    {...this.props}
                    plans={this.props.plans.details}
                    onPlanUpdate={this.updateCurrentPlan}
                    context={matrixContext} />
            );
        } else {
            let showFinePrint = [
                constants.PUB_LEVEL_6,
                constants.PUB_LEVEL_9,
                constants.PUB_LEVEL_8,
                constants.PUB_LEVEL_10
            ];

            let specialPriceDisclaimer = null
            if (this.state.newSubscription.level === constants.PUB_LEVEL_6) {
                specialPriceDisclaimer = <span><br/>$99 annual offer will be applied to your first year</span>;
            }

            let disclaimers = null;
            disclaimers = (
                <div>
                    <p>* X (Twitter) is limited to 500 posts / month per Twitter account. Add additional X Posts at any time.</p>
                </div>
            );


            content = (
                <div>
                    <PlanDetailBlock
                        {...this.props}
                        context={this.props.context}
                        currentPlan={this.state.newSubscription.level}
                        currentTerm={this.state.newSubscription.term}
                        currentAddOns={this.state.newSubscription.addOns}
                        goToSignup={this.goToSignup}
                        startUpgrade={this.startUpgrade}
                        processing={this.state.processing}
                        changePlanView={this.changePlanView}
                        updateCurrentPlan={this.updateCurrentPlan} />
                    {additionalPlan}
                    {(showFinePrint.indexOf(this.state.newSubscription.level) !== -1) ? (
                        <div className="plan-fine-print">
                            {disclaimers}
                            {specialPriceDisclaimer}
                        </div>
                    ) : null}
                    <div className="supported-networks">
                        <SupportedNetworks {...this.props}/>
                    </div>
                </div>
            );
        }

        let secondaryLabel = '',
            secondaryAction = this.startUpgrade,
            secondarButtonClass = 'btn-primary active subscription-button';

        if (this.props.context === 'app' || this.props.context === 'new-subaccount') {
            //secondaryLabel = `Get ${this.props.plans.details[this.state.newSubscription.level].label} today`;
            secondaryLabel = "Get Started";
        } else {
            secondarButtonClass += ' public';
            secondaryLabel = "Sign Up and Try Pro Free";
            secondaryAction = this.props.goToSignup;
        }


        return (
            <ErrorBoundary level="view" {...this.props}>
                <div>
                    <div className={containerClass}>
                        <div className={subscriptionBlockClass}>
                            {content}
                        </div>
                        <div className="static-block">
                            <SubscriptionFeatureBlock {...this.props} />
                            {plusPitch}
                            <div className="cta-secondary">
                                <div className={secondarButtonClass} onClick={secondaryAction} role="button" aria-label={secondaryLabel}>
                                    {secondaryLabel}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ErrorBoundary>
        );
    }

};

SubscriptionNew.displayName = "SubscriptionNew";

SubscriptionNew.propTypes = {
    recordPath: PropTypes.func,
    getSavedPath: PropTypes.func,
    context: PropTypes.string,
    plans: PropTypes.object,
    testimonials: PropTypes.array,
    bannerVisible: PropTypes.bool
};

SubscriptionNew.defaultProps = {
    recordPath: null,
    getSavedPath: null,
    context: 'app',
    plans: {},
    testimonials: [],
    bannerVisible: false,
};

export default ComponentWithContext(SubscriptionNew);
